import { render, staticRenderFns } from "./botaoVoltar.vue?vue&type=template&id=6351ec76"
import script from "./botaoVoltar.vue?vue&type=script&lang=ts"
export * from "./botaoVoltar.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports